import 'chartjs-plugin-datalabels';
import { FormatAsDollars } from '../../../utils/Helpers/Format';

const chartOptions = ({
  opts,
  rateValue,
  isLowest,
  yAxesLabel,
  savedLabel,
}) => {
  const isMobile = window.innerWidth < 768;

  return {
    maintainAspectRatio: isMobile ? false : true,
    responsive: true,
    aspectRatio: isMobile ? 1 : 1,
    tooltips: {
      mode: 'index',
      callbacks: {
        label: function (tooltipItem, data) {
          const value = FormatAsDollars(
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
          );
          const label = data.datasets[tooltipItem.datasetIndex].label || '';
          return ` ${label}: ${value}`;
        },
        title: function (tooltipItems, data) {
          const total = tooltipItems.reduce(function (acc, item) {
            return acc + item.yLabel;
          }, 0);
          return `${tooltipItems[0].xLabel.join(' ')}: ${FormatAsDollars(
            total
          )}`;
        },
      },
    },
    legend: {
      reverse: true,
      position: isMobile ? 'top' : 'bottom',
      onClick: function (e) {
        e.stopPropagation();
      },
      labels: {
        fontSize: isMobile ? 14 : 16,
        fontColor: '#262626',
        padding: isMobile ? 5 : 20,
        fontFamily: 'Lato',
        boxWidth: 20,
      },
    },
    layout: {
      padding: isMobile ? 0 : 20,
    },
    scales: {
      yAxes: [
        {
          display: true,
          stacked: true,
          gridLines: {
            display: true,
            color: 'rgba(102, 99, 102, 0.33)',
          },
          ticks: {
            callback: function (value) {
              if (value > 999 && isMobile) {
                return `$${(value / 1000).toFixed(0)}K`;
              }
              return `$${value.toFixed(0)}`;
            },
            fontSize: isMobile ? 14 : 16,
            fontColor: '#000000',
            fontFamily: 'Lato',
            padding: 15,
            maxTicksLimit: 6,
          },
          scaleLabel: {
            display: true,
            labelString: yAxesLabel,
            fontSize: 14,
            fontWeight: 800,
            fontColor: '#262626',
            fontFamily: 'Lato',
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
            color: 'rgba(102, 99, 102, 0.33)',
          },
          stacked: true,
          barThickness: isMobile ? 30 : 60,
          categorySpacing: 10,
          ticks: {
            fontSize: isMobile ? 12 : 16,
            fontWeight: 400,
            fontColor: '#262626',
            fontFamily: 'Lato',
            callback: function (value) {
              if (!isMobile) return value;
              const maxLabelLength = isMobile ? 10 : 20;
              const newLabels = value.map((label) =>
                label.match(new RegExp('.{1,' + maxLabelLength + '}', 'g'))
              );
              return newLabels.flat();
            },
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          if (ctx.datasetIndex !== ctx.chart.data.datasets.length - 1)
            return '';
          return ctx.dataIndex === 0
            ? isLowest
              ? `${FormatAsDollars(rateValue.toFixed(0))} ${savedLabel}`
              : ''
            : opts[ctx.dataIndex].savings && opts[ctx.dataIndex].savings > 0
            ? `${FormatAsDollars(
                opts[ctx.dataIndex].savings.toFixed(0)
              )} ${savedLabel}`
            : '';
        },
        align: 'end',
        anchor: 'end',
        color: (ctx) => {
          return '#000000';
        },
        font: {
          weight: isMobile ? 400 : 800,
          size: isMobile ? 10 : 16,
          lineHeight: 1.2,
          family: 'Lato',
        },
      },
    },
  };
};

export default chartOptions;
